import { useState } from 'react';
import type { OpenModalInput } from '../types';

type LedgerModalState = Required<OpenModalInput> & {
  open: boolean;
  currentLedgerName?: string;
};

const useLedgerModalHandle = () => {
  const initialState: LedgerModalState = {
    open: false,
    cx: {},
    accountId: null,
    groupId: null,
    title: '',
    filterAccountTypeCd: '',
    restrictedflag: null,
    initialBankDetails: null,
    currentLedgerName: '',
  };
  const [ledgerModalParams, setLedgerModal] = useState<LedgerModalState>(initialState);

  const openLedgerModal = (params?: OpenModalInput) => {
    setLedgerModal((prev) => ({
      ...prev,
      open: true,
      cx: params?.cx ?? {},
      accountId: Number(params?.accountId) ?? null,
      groupId: Number(params?.groupId) ?? null,
      title: params?.title ?? '',
      filterAccountTypeCd: params?.filterAccountTypeCd ?? '',
      restrictedflag: params?.restrictedflag ?? null,
      initialBankDetails: params?.initialBankDetails ?? null,
      currentLedgerName: params?.title ?? '',
    }));
  };

  const closeLedgerModal = () => {
    setLedgerModal(initialState);
  };

  const updateCurrentLedgerName = (ledgerName: string) => {
    setLedgerModal((prev) => ({
      ...prev,
      currentLedgerName: ledgerName,
    }));
  };

  return {
    ledgerModalParams,
    openLedgerModal,
    closeLedgerModal,
    updateCurrentLedgerName,
  };
};

export { useLedgerModalHandle, type OpenModalInput };
